import React from 'react'

/**
 * AbwaabPlus Badge / Pill — fully-rounded label carrying status meaning.
 * Tinted tones use a semantic hue @10% with the matching saturated text color.
 */
export type AbwBadgeTone =
	| 'blue'
	| 'blue-solid'
	| 'gray'
	| 'success'
	| 'success-tint'
	| 'error'
	| 'error-tint'
	| 'warning'
	| 'highlight'

const TONES: Record<AbwBadgeTone, React.CSSProperties> = {
	blue: { background: 'var(--blue-10)', color: 'var(--blue)' },
	'blue-solid': { background: 'var(--blue)', color: 'var(--text-on-brand)' },
	gray: { background: 'var(--surface-sunken-strong)', color: 'var(--text-secondary)' },
	success: { background: 'var(--success)', color: 'var(--text-on-brand)' },
	'success-tint': { background: 'var(--success-10)', color: 'var(--success-dark)' },
	error: { background: 'var(--error)', color: 'var(--text-on-brand)' },
	'error-tint': { background: 'var(--error-10)', color: 'var(--error-dark)' },
	warning: { background: 'var(--warning-10)', color: 'var(--warning-dark)' },
	highlight: { background: 'var(--yellow)', color: 'var(--navy)' },
}

export interface AbwBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
	tone?: AbwBadgeTone
	leadingIcon?: React.ReactNode
}

export function Badge({ tone = 'gray', leadingIcon, children, style, ...rest }: AbwBadgeProps) {
	return (
		<span
			style={{
				display: 'inline-flex',
				alignItems: 'center',
				gap: 4,
				font: 'var(--fw-medium) 12px var(--font-sans)',
				borderRadius: 'var(--r-full)',
				padding: '2px 8px',
				whiteSpace: 'nowrap',
				...TONES[tone],
				...style,
			}}
			{...rest}
		>
			{leadingIcon}
			{children}
		</span>
	)
}
